export default __webpack_public_path__ + "static/media/blog04.16fbca3c.png";